var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConversation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 41 41"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "Conversation_svg__a",
  d: "M26.312 24.955q.728-.05 1.442-.157l.464-.07 6.17 5.512.03-7.895.426-.297C38.108 19.772 40 16.498 40 13c0-6.576-6.675-12-15-12-3.984 0-7.59 1.242-10.268 3.258l-.14.107C11.757 6.555 10 9.626 10 13c0 6.576 6.675 12 15 12q.657 0 1.305-.045zm-1.024 1.043L25 26c-8.837 0-16-5.82-16-13q0-.15.004-.3C4.214 14.254 1 18.14 1 22.5c0 2.986 1.497 5.782 4.094 7.767l.39.298.038 6.088 4.489-4.059.497.103c.97.2 1.973.303 2.992.303 5.368 0 10.048-2.87 11.788-7.002m-16.2-14.37C9.932 5.093 16.734 0 25 0c8.837 0 16 5.82 16 13 0 3.947-2.165 7.484-5.584 9.868l-.033 8.487a.5.5 0 0 1-.833.37l-6.65-5.937q-.749.112-1.52.165C24.661 30.617 19.544 34 13.5 34c-1.1 0-2.17-.112-3.195-.324l-4.94 4.468a.5.5 0 0 1-.836-.368l-.042-6.714C1.733 28.956 0 25.9 0 22.5c0-5.035 3.799-9.314 9.088-10.872"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "Conversation_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Conversation_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Conversation_svg__a",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#Conversation_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-1h41v41H0z"
})))));
export default SvgConversation;